import { api } from "./configs/axiosConfigs"

export const SellersAPI = {
    getSellers: async (data:any) => {
        const response = await api.get(
            '/salesman', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getSellersERP: async () => {
        const response = await api.get(
            '/softnet/vendedor'
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getSellersByCompany: async (data:any) => {
        const response = await api.get(
            '/salesman/listByCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createSeller: async (data: any) => {
        const response = await api.post(
            '/salesman/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editSeller: async (idseller: number, data: any) => {
        const response = await api.patch(
            `/salesman/${idseller}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteSeller: async (idseller: number) => {
        const response = await api.delete(
            `/salesman/${idseller}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}